/**
 * Simple audio player singleton for managing song playback
 */
class AudioPlayerManager {
  constructor() {
    this.audio = null;
    this.currentSongId = null;
    this.listeners = new Set();
  }

  play(songId, previewUrl) {
    // If playing the same song, just resume
    if (this.currentSongId === songId && this.audio) {
      this.audio.play();
      this.notifyListeners(songId, true);
      return;
    }

    // Stop current song if any
    this.stop();

    // Create new audio element
    this.audio = new Audio(previewUrl);
    this.currentSongId = songId;

    // Play the song
    this.audio.play().catch((error) => {
      console.error('Failed to play audio:', error);
    });

    // Handle when song ends
    this.audio.addEventListener('ended', () => {
      this.stop();
    });

    this.notifyListeners(songId, true);
  }

  pause() {
    if (this.audio) {
      this.audio.pause();
      this.notifyListeners(this.currentSongId, false);
    }
  }

  stop() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
    }
    const prevSongId = this.currentSongId;
    this.currentSongId = null;
    this.notifyListeners(prevSongId, false);
  }

  isPlaying(songId) {
    return this.currentSongId === songId && this.audio && !this.audio.paused;
  }

  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  notifyListeners(songId, isPlaying) {
    this.listeners.forEach((callback) => callback(songId, isPlaying));
  }
}

// Export singleton instance
export const audioPlayer = new AudioPlayerManager();
